import { RESOURCES, API_BASE_URL } from '../utils/constants/constants';
import {  fetchData } from '../utils/fetchData';

const JWT_RESOURCEES = RESOURCES.jwt;

const getTableauToken = () => {
  const VITE_LOCAL_TABLEAU_PROVIDER_URL = import.meta.env.VITE_LOCAL_TABLEAU_PROVIDER_URL;
  const resource = VITE_LOCAL_TABLEAU_PROVIDER_URL || `${API_BASE_URL}${JWT_RESOURCEES.getTableauToken}`;
  return fetchData(resource);
}

export { getTableauToken };
